(function () {
    'use strict';

    angular.module('iMatApp')
        .factory('$exceptionHandler', generalErrorHandlerService);

    generalErrorHandlerService.$inject = ['$log', '$injector'];

    function generalErrorHandlerService($log, $injector) {

        return function myExceptionHandler(exception, cause) {
            if (exception instanceof Upload3DModelGeneralError) {

                var mainWorkspace = $injector.get('mainWorkspace');
                var errorHandler = $injector.get('modelProcessingErrorHandler');

                var model = mainWorkspace.product.model;
                var issue = errorHandler.handle(model, exception.reason);

                mainWorkspace.issue = issue;
            
            } else {
                $log.error(exception, cause);
            }
        };
    }
})();